export const axoSupportPhoneNumber = '+4722867400';
